import { toast as toastify } from 'react-toastify';

import { Toast } from '../components/common';

export const toast = (message, severity = 'success') =>
  toastify(Toast, { data: { message, severity } });
